/* eslint-disable jsx-a11y/no-static-element-interactions */
/**
 * A component to be used to display content of media item in a list.
 *
 * @module components/MediaListItem/MediaListItem
 */

import classNames from 'classnames';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

import Img from '../../components/ImageLoader/ImageLoader';
import QA from '../../constants/QATags';
import { PandoraTypes } from '../../constants/SourceTypes';
import { StationConstants } from '../../constants/StationConstants';
import { AppContextIntegrationData } from '../../lib/Context';
import ListItemMixin from '../../mixins/ListItemMixin';

import './MediaListItem.scss';

export const MediaListItem = createReactClass({
  displayName: 'MediaListItem',

  propTypes: {
    id: PropTypes.string,
    pandoraId: PropTypes.string,
    shareParentSourceId: PropTypes.string,
    shareParentSourceType: PropTypes.oneOf(Object.values(PandoraTypes)),
    listItemId: PropTypes.string,
    art: PropTypes.string,
    primaryBackstagePath: PropTypes.string,
    primaryText: PropTypes.string,
    secondaryText: PropTypes.string,
    secondaryBackstagePath: PropTypes.string,
    tertiaryText: PropTypes.string,
    tertiaryBackstagePath: PropTypes.string,
    openDropdown: PropTypes.func,
    closeDropdown: PropTypes.func,
    startStation: PropTypes.func,
    openShareModal: PropTypes.func,
    isOverlayShown: PropTypes.bool,
    dropdownOptions: PropTypes.object,
    isBackstage: PropTypes.bool,
    imageQATag: PropTypes.string,
    primaryTextQATag: PropTypes.string,
    secondaryTextQATag: PropTypes.string,
    tertiaryTextQATag: PropTypes.string,
    ellipsisQATag: PropTypes.string,
    componentName: PropTypes.string,
  },

  contextTypes: {
    router: PropTypes.object,
  },

  mixins: [ListItemMixin],

  getDefaultProps() {
    return {
      imageQATag: QA.TTI,
      primaryTextQATag: QA.TNL,
      secondaryTextQATag: QA.TANL,
      tertiaryTextQATag: QA.TSNL,
      ellipsisQATag: QA.TOMB,
    };
  },

  getInitialState() {
    return {
      isDropdownOpen: false,
    };
  },

  componentWillUnmount() {
    if (this.state.isDropdownOpen) {
      this.props.closeDropdown();
    }
  },

  onDeadSpaceClick(e) {
    if (!this.props.isBackstage) {
      this.context.router.push(this.props.primaryBackstagePath);
    }
    e.preventDefault();
  },

  onCreateStation() {
    this.props.startStation({
      rerouteBasedOnTier: true,
      stationCodePrefix: StationConstants.MUSIC_ID,
      musicId: this.props.id,
      componentName: this.props.componentName ? this.props.componentName : 'MediaListItem',
    });
  },

  onShareClick() {
    const { pandoraId, shareParentSourceId, shareParentSourceType } = this.props;
    this.props.openShareModal(
      pandoraId,
      shareParentSourceType ? { shareParentSourceId, shareParentSourceType } : {},
    );
  },

  onCloseDropdown() {
    this.setState(
      {
        isDropdownOpen: false,
      },
      () => {
        if (!this.state.mousedover) {
          this.onMouseLeaveListItem();
        }
      },
    );
  },

  onMenuClick(event) {
    const rect = event.target.getBoundingClientRect();
    this.props.openDropdown({
      menuType: this.props.dropdownOptions.menuType,
      config: {
        position: rect,
        onCreateStation: this.onCreateStation,
        onCloseDropdown: this.onCloseDropdown,
        onShareClick: this.onShareClick,
        ...this.props.dropdownOptions.config,
      },
    });
    this.setState({ isDropdownOpen: true });
    event.stopPropagation();
  },

  renderThumbnailImage() {
    return (
      <div
        className='MediaListItem__thumbnail__image MediaListItem__innerContent'
        data-qa={this.props.imageQATag}
        onMouseEnter={this.onMouseEnterThumbnail}
        onMouseLeave={this.onMouseLeaveThumbnail}
      >
        <Img src={this.props.art} alt={this.props.primaryText} doesFade={false} />
      </div>
    );
  },

  onMouseLeavePreventDefault() {
    return this.state.isDropdownOpen;
  },

  renderMenuButton() {
    if (!this.state.listItemHovered) {
      return null;
    }
    if (this.props.dropdownOptions) {
      return (
        <div className='MediaListItem__rightContent MediaListItem__innerContent'>
          <div
            className='MediaListItem__ellipsis'
            data-qa={this.props.ellipsisQATag}
            onClick={this.onMenuClick}
          >
            ...
          </div>
        </div>
      );
    }
  },

  renderSecondaryText() {
    if (this.props.isBackstage) {
      return (
        <div className='MediaListItem__secondaryText' data-qa={this.props.secondaryTextQATag}>
          {this.props.secondaryText}
        </div>
      );
    }
    return (
      <Link
        to={this.props.secondaryBackstagePath}
        data-qa={this.props.secondaryTextQATag}
        className='MediaListItem__secondaryText'
      >
        {this.props.secondaryText}
      </Link>
    );
  },

  renderPrimaryText() {
    if (this.props.isBackstage) {
      return (
        <div className='MediaListItem__primaryText' data-qa={this.props.primaryTextQATag}>
          {this.props.primaryText}
        </div>
      );
    }
    return (
      <Link
        to={this.props.primaryBackstagePath}
        data-qa={this.props.primaryTextQATag}
        className='MediaListItem__primaryText'
      >
        {this.props.primaryText}
      </Link>
    );
  },

  renderInfo() {
    const optionalInfo = [];
    if (this.props.secondaryText) {
      optionalInfo.push(<div key='secondary'>{this.renderSecondaryText()}</div>);
    }
    if (this.props.tertiaryText) {
      optionalInfo.push(
        <div
          key='tertiary'
          className='MediaListItem__tertiaryText'
          data-qa={this.props.tertiaryTextQATag}
        >
          {this.props.tertiaryText}
        </div>,
      );
    }
    return (
      <div className='MediaListItem__info MediaListItem__innerContent'>
        <div key='primary'>{this.renderPrimaryText()}</div>
        {optionalInfo}
      </div>
    );
  },

  onContainerMouseEnter() {
    if (!this.props.isBackstage) {
      return this.onMouseEnterListItem();
    }
  },

  onContainerMouseLeave() {
    if (!this.props.isBackstage) {
      return this.onMouseLeaveListItem();
    }
  },

  onThumbnailMouseEnter() {
    if (this.props.isBackstage) {
      return this.onMouseEnterListItem();
    }
  },

  onThumbnailMouseLeave() {
    if (this.props.isBackstage) {
      return this.onMouseLeaveListItem();
    }
  },

  getIntegrationData() {
    return {
      pandoraId: this.props.pandoraId,
    };
  },

  render() {
    const listItemClass = classNames({
      MediaListItem: true,
      'MediaListItem--hovered': this.state.listItemHovered,
      'MediaListItem--backstage': this.props.isBackstage,
    });

    return (
      <AppContextIntegrationData data={this.getIntegrationData}>
        <div
          className={listItemClass}
          onMouseEnter={this.onContainerMouseEnter}
          onMouseLeave={this.onContainerMouseLeave}
          onClick={this.onDeadSpaceClick}
        >
          <div
            className='MediaListItem__thumbnail'
            onMouseEnter={this.onThumbnailMouseEnter}
            onMouseLeave={this.onThumbnailMouseLeave}
          >
            {this.renderThumbnailImage()}
          </div>
          {this.renderInfo()}
          {this.renderMenuButton()}
        </div>
      </AppContextIntegrationData>
    );
  },
});

export default MediaListItem;
